import React from "react";


export default function FieldColor_InlineValueNotEmpty(props:any) {

    const classes = Classes("ui5-color-picker", "gd-c-"+props.option.value);

    return (
        <React.Fragment>
            <div className="ui5-field-dropdown-inline-editable" onClick={props.onClick}>
                <div className={classes} ></div>
            </div>

            {props.children}
        </React.Fragment>
    )
}
